import Dexie from 'dexie';

//GENERAR BASE DE DATOS LOCAL
export const db = new Dexie('telefonosMSM');
db.version(1).stores(
    { phones: "++id,user,telefono" }
);